import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import PartnerDisclosure from "../../components/automap/partnerships/PartnerDisclosure";
import PartnerLeadForm from "../../components/automap/partnerships/PartnerLeadForm";
import {
  PARTNERSHIP_ANALYTICS_EVENTS,
  SERVICE_PAGE_CONFIG,
  SLUG_TO_CATEGORY,
  getCategoryLabel,
} from "../../constants/automapPartnershipConstants";
import { trackPartnershipEvent } from "../../services/automapPartnershipApi";
import "../../styles/partnerships.css";

export default function ServiceCategoryPage() {
  const { serviceSlug } = useParams();
  const category = SLUG_TO_CATEGORY[serviceSlug];
  const config = category ? SERVICE_PAGE_CONFIG[category] : null;

  useEffect(() => {
    if (config) {
      document.title = `${config.title} | AutoMapa`;
      trackPartnershipEvent(PARTNERSHIP_ANALYTICS_EVENTS.SERVICE_CARD_VIEWED, {
        category,
        sourcePage: `/servicios/${serviceSlug}`,
      });
    }
  }, [category, config, serviceSlug]);

  if (!category || !config) {
    return (
      <div className="partnerships-page">
        <main className="partnerships-page__main">
          <p>Servicio no encontrado.</p>
          <Link to="/servicios">Volver a servicios</Link>
        </main>
      </div>
    );
  }

  return (
    <div className="partnerships-page">
      <header className="partnerships-page__hero">
        <div className="wrap">
          <Link to="/servicios" style={{ color: "#b2ddff", fontSize: "0.9rem" }}>
            ← Todos los servicios
          </Link>
          <span className="partnerships-page__eyebrow" style={{ display: "block", marginTop: "0.75rem" }}>
            {getCategoryLabel(category)}
          </span>
          <h1>{config.title}</h1>
          <p>{config.hero}</p>
        </div>
      </header>
      <main className="partnerships-page__main">
        <section className="partnerships-card">
          <h2>Cuándo usarlo</h2>
          <p>{config.whenToUse}</p>
        </section>

        <section style={{ marginTop: "1.25rem" }}>
          <PartnerLeadForm
            category={category}
            sourcePage={`/servicios/${serviceSlug}`}
            sourceComponent="service_page_form"
            sourceAction="submit"
          />
        </section>

        {config.guideLinks?.length ? (
          <section className="partnerships-card" style={{ marginTop: "1rem" }}>
            <h2>Guías relacionadas</h2>
            <ul>
              {config.guideLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href}>{link.label}</Link>
                </li>
              ))}
            </ul>
            <Link to="/checklist-compra" className="partnerships-btn partnerships-btn--soft" style={{ marginTop: "0.5rem" }}>
              Ver checklist de compra
            </Link>
          </section>
        ) : null}

        <PartnerDisclosure category={category} />

        {config.faq?.length ? (
          <section className="partnerships-faq">
            <h2>Preguntas frecuentes</h2>
            {config.faq.map((item) => (
              <details key={item.q}>
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </section>
        ) : null}
      </main>
    </div>
  );
}
